import { Component, forwardRef } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TagInput } from './tag-input';
import { AppService } from '@data/services/app.service';

@Component({

    selector: 'syn-app-tag-input',
    templateUrl: 'tag-input.html',
    styleUrls: ['tag-input.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AppTagInputComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => AppTagInputComponent), multi: true }
    ]
})
export class AppTagInputComponent extends TagInput {
    constructor(appservice: AppService) {
        super(appservice);
    }
}
